import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

import firebase from "../../firebase";
import NewSalonTypeForm from "./newsalontypeform";
import Service from "../../Service/firebase";

import "./addsalontype.css";

const AddSalonType = (props) => {
  const [imageAvatar, setImageAvatar] = useState("");
  const [imagefile, setImagefile] = useState("");
  const [date, setDate] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [htmlelement, setHtmlelement] = useState(
    <i className="fa fa-user fa-8x" aria-hidden="true"></i>
  );
  const [formData, setFormData] = useState({
    name: "",
  });

  const handleSubmit = () => {
    setIsLoading(true);
    props.setCloseBtnAppear();
    handleImageForUpload();
  };
  const handleImageForUpload = () => {
    const image = imagefile;
    const url = "";

    if (imagefile !== "") {
      onUploadImage(image);
    } else {
      onAddPerson(url);
    }
  };
  const onUploadImage = async (image) => {
    const url = await Service.uploadImage(image);
    if (url !== "") {
      onAddPerson(url);
    }
  };
  const onAddPerson = async (imageUrl) => {
    let sendData = {
      ...formData,
      searchbyname: formData.name.toLowerCase(),
      imgaeurl: imageUrl,
      timeStamp: firebase.firestore.Timestamp.fromDate(new Date()),
    };
    if (props.collectionName === "patients") {
      sendData = {
        ...sendData,
        bedallotementid: "",
        operationreportid: "",
        birthreportid: "",
        deathreportid: "",
      };
    }

    const res = await Service.addDataSalontype(
      sendData,
      props.collectionName,
      props.id
    );

    if (res === "success") {
      setIsLoading(false);
      props.handleSuccessDailog();
    } else {
      setIsLoading(false);
      props.handleErrorDailog();
    }
  };

  const handleChange = (date) => {
    if (date !== null) {
      const birthDate = new Date(date);
      setDate(date);
      setFormData({
        ...formData,
      });

      setStartDate(date);
    } else {
      setDate(date);
      setFormData({
        ...formData,
      });
      setStartDate(date);
    }
  };
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImagefile(event.target.files[0]);
      let reader = new FileReader();
      reader.onload = (e) => {
        setImageAvatar(e.target.result);
        setHtmlelement(
          <div className="addpersonpage">
            <img
              className="netimage"
              srcSet={e.target.result}
              alt="profileImage"
            />
          </div>
        );
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };
  const onImageRemove = () => {
    setImagefile("");
    setImageAvatar("");
    setHtmlelement(
      <div className="addpersonpage">
        <i className="fa fa-user fa-8x" aria-hidden="true"></i>
      </div>
    );
  };
  const onEdit = (e) => {
    const formData = this.state.formData;
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // if (this.state.imageAvatar === "") {
  //   this.state.htmlelement = (
  //     <div className="addpersonpage">
  //       <i className="fa fa-user fa-8x" aria-hidden="true"></i>
  //     </div>
  //   );
  // } else {
  //   this.state.htmlelement = (
  //     <div className="addpersonpage">
  //       <img className="netimage" srcSet={this.state.imageAvatar} alt="" />
  //     </div>
  //   );
  // }
  return isLoading ? (
    <div className="addpersonpage">
      <i className="fas fa-spinner fa-pulse fa-2x"></i>
    </div>
  ) : (
    <div className="addpersonpage">
      <div className="container main_section">
        <div className="row">
          <div className="col-sm">
            <NewSalonTypeForm
              handleSubmit={handleSubmit}
              onEdit={onEdit}
              // startDate={startDate}
              date={date}
              htmlelement={htmlelement}
              handleChange={handleChange}
              onImageRemove={onImageRemove}
              onImageChange={onImageChange}
            ></NewSalonTypeForm>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddSalonType;
